export default theme => ({
    div: {
        fontWeight: 500,
        color: theme.palette.text.secondary
    },
    popover:{},
    popoverPorlet:{
        backgroundColor:"grey",
    },
    textColorPopover:{
        color:"white"
    },
    stopGreen:{
        color:"rgb(18, 188, 92)"
    },
    stopYellow:{
        color:"#dde00a"
    },
    updateTime:{
        fontWeight: 500,
        /* width: '200px' */
    },
    rounded: {
            color: '#3b3b3b',
            backgroundColor: '#fff',
            height: '30px'
    },
    buttonClosed:{
        textAlign:"right",
        color:'white'
    },
    root: {
        padding: 0,
    },
    content: {
        paddingRight: 0,
        paddingLeft: 0,
    }
});
